import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Container, Typography } from '@mui/material';

import Navigation from '../Shared/Navigation/Navigation';
import Footer from '../Shared/Footer/Footer';
import Course from '../Home/Course/Course';



const Explore = () => {
    const [courses, setCourses] = useState([]);

    const spinnerStyle = {
        width: "3rem",
        height: "3rem",
    };
    // load courses from the server
    useEffect(() => {
        fetch('https://warm-oasis-84574.herokuapp.com/explore')
            .then(res => res.json())
            .then(data => setCourses(data))
    }, []);
    return (
        <>
            <Navigation></Navigation>
            <Box sx={{ flexGrow: 1 }}>
                <Container >
                    <Typography variant="h1" className="heading" style={{ pb: 0, fontWeight: "700" }} data-aos="zoom-out-up" data-aos-duration="1000" data-aos-easing="ease-in-sine"
                        gutterBottom>

                        <span>F</span>
                        <span>E</span>
                        <span>A</span>
                        <span>T</span>
                        <span>U</span>
                        <span>R</span>
                        <span>E</span>
                        <span>D</span>
                        <span className="space">{""}</span>
                        <span className="space">{""}</span>
                        <span>C </span>
                        <span>O</span>
                        <span>U</span>
                        <span>R</span>
                        <span>S</span>
                        <span>E</span>
                        <span>S</span>

                    </Typography>
                    {!courses.length ? (
                        <div className="text-center my-5 py-5">
                            <div
                                className="spinner-grow color-1 mt-5"
                                style={spinnerStyle}
                                role="status"
                            >
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 6, sm: 6, md: 12 }}>
                            {
                                courses.map(course => <Course
                                    key={course.key}
                                    course={course}
                                ></Course>)
                            }
                        </Grid>

                    )}


                </Container>
            </Box>
            <Footer></Footer>
        </>
    );
};

export default Explore;